module.exports = __webpack_public_path__ + "media/Dark.48587e04.wav";